import { Component, OnInit, OnDestroy, Inject, ViewChild } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';

import { ConfigurationService } from '../configuration.service';
import { ApiUploadedFile} from '../api-client-module';
import { AppConst } from '../app-const';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-select-angular-icon-dialog',
  templateUrl: './select-angular-icon-dialog.component.html',
  styleUrls: ['./select-angular-icon-dialog.component.css'],
  standalone: false,
})
export class SelectAngularIconDialogComponent implements OnInit, OnDestroy {

  projectId: string;

  displayedColumns: string[] = ['position', 'select', 'category', 'image', 'name'];
  dataSource = new MatTableDataSource<any>();

  @ViewChild(MatPaginator, {static: true}) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort!: MatSort;

  constructor(
    public dialogRef: MatDialogRef<SelectAngularIconDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ApiUploadedFile,
    private configurationService: ConfigurationService,
    private translate: TranslateService
  ) {
    this.projectId = this.configurationService.getProjectId();
  }

  public icons = AppConst.ANGULAR_MATERIAL_ICONS;

  ngOnInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    const data: any[] = [];
    for (const row of AppConst.ANGULAR_MATERIAL_ICONS) {
      for (const icon of row.icons) {
        data.push(
          {
            category: row.category,
            name: icon,
          }
        );
      }
    }
    this.dataSource.data = data;
  }

  ngOnDestroy(): void {
  }

  selectIcon(row: any) {
    this.dialogRef.close(row);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  sortData(sort: Sort) {
    const data = this.dataSource.data.slice();
    if (!sort.active || sort.direction === '') {
      this.dataSource.data = data;
      return;
    }
    const compare = (a: number | string, b: number | string, isAsc: boolean) => {
      return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    }

    this.dataSource.data = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'category':
          return compare(a.category, b.category, isAsc);
        case 'name':
          return compare(a.name.substr(14), b.name.substr(14), isAsc);
        default:
          return 0;
      }
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  applyFilterCategory(event: any) {
    const data: any[] = [];
    const filterValue = event.value;
    for (const row of AppConst.ANGULAR_MATERIAL_ICONS) {
      if (!filterValue || filterValue === row.category) {
        for (const icon of row.icons) {
          data.push(
            {
              category: row.category,
              name: icon,
            }
          );
        }
      }
    }
    this.dataSource.data = data;
  }
}
